import { withMetadata } from '../metadata'
import { searchNumbers as _searchNumbers } from '../../core/index'

export function searchNumbers() {
	return withMetadata(_searchNumbers, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/searchNumbers.js
// module id = 627
// module chunks = 0